import React from "react";
import { connect } from "react-redux";
import { WithModal, IconLabel } from "ctia-ui";
import ConfirmPaymentModalASC from "containers/ControlPanel/Payments/ASC/ConfirmPaymentASC/ConfirmPaymentModalASC";
import { showNotice } from "actions/notifier";
import { notifyMessages } from "helpers/NotifyHelper";

class ConfirmPaymentASC extends WithModal {
  modalHandler = () => {
    const { asc, showNotice } = this.props;

    if (asc.isBackgroundJobRunning) {
      return showNotice(notifyMessages.backgroundJobInActionWarning);
    }

    this.handleModal();
  };

  render() {
    return this.props.showLink ? (
      <div>
        <IconLabel awesomeIcon="check" />{" "}
        <span className="glow-link cursor-pointer" onClick={this.modalHandler}>
          Confirm Payment
        </span>
        <ConfirmPaymentModalASC
          show={this.state.showModal}
          modalHandler={this.handleModal}
          {...this.props}
        />
      </div>
    ) : null;
  }
}

function mapStateToProps({ asc }) {
  return { asc };
}

export default connect(mapStateToProps, { showNotice })(ConfirmPaymentASC);
